import { GlobalState } from '../reducers';
import { MobileNumberData, OtpData } from '../reducers/login';

export const getMobileNumberData = (state: GlobalState): MobileNumberData =>
    state.login.mobileNumber;
export const getOtpData = (state: GlobalState): OtpData => state.login.otp;
